// Minimum eight characters, at least one uppercase letter, one lowercase letter and one numbers
export const passwordValidator = (value) =>
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/.test(value)

export const vinValidator = (value) => /[IOQioq\w]{17}$/.test(value)

export const vinValidatorNotRequired = (value) => {
  return value === '' || /[IOQioq\w]{17}$/.test(value)
}

export const phoneNumberValidator = (value) =>
  /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(value)

export const creditCardValidator = (value) =>
  /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/.test(
    value
  )

export const maxNameInputValidator = (value) => value.length < 21

// Used to validate select dropdown initial values
export const notNull = (value) => value !== null

export const alphanumericValidator = (value) =>
  /^([-A-Za-z0-9 ]){1,20}$/.test(value)

export const aphaSpace = (value) => /^[A-Za-z ]+$/.test(value)

export const nameValidator = (value) => /^[A-Za-z- ]*$/.test(value)

export const usaCanZipValidator = (value) =>
  /^[0-9]{5}$|^[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]$/.test(value)
